import React, { useState, useEffect, useRef } from 'react';
import { Button, Modal, Form, InputGroup, Row, Col } from 'react-bootstrap';
import Header from "../../../Components/Header/Header";
import { LeftSettings } from '../LeftSettings';
import { MultiSelect } from 'react-multi-select-component';
import StationDetails from './StationDetails';
import Tab from 'react-bootstrap/Tab';
import Tabs from 'react-bootstrap/Tabs';
import Trash from "../../../assets/images/delete.svg";
import Edit from "../../../assets/images/edit.png";
import Arcv from "../../../assets/images/archive.svg";
import Active from "../../../assets/images/active.svg";
import Select from 'react-select';
import { toast } from 'react-toastify';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faPlus, faLink } from '@fortawesome/free-solid-svg-icons';

import { withoutRFSToken, withRFSToken, } from '../../../Services/axios.js';
import { STATIONS, RULESADDUPDATE, RULESDELETERESTORE, GETTYPECODE, SAVEMSGRULE, MSGSETTINGLIST } from '../../../Utils/conts.js';
import LeftMenu from '../../../Components/LeftMenu/LeftMenu.js';


export const StockAllotmentSettings = ({ onGridDataUpdate }) => {

  const isMounted = useRef(false);
  const [isLoading, setIsLoading] = useState(true);
  const [stationData, setStationData] = useState([]);
  const [getTypeCodes, setGetTypeCodes] = useState([]);
  const [confModal, setConfModal] = useState(false);
  const [confNotificationModal, setConfNotificationModal] = useState(false);
  const [deviationRangeModal, setDeviationRangeModal] = useState(false);
  const [stockAllotmentNotificationModal, setStockAllotmentNotificationModal] = useState(false);
  const [modalShow, setModalShow] = useState(false);
  const [showDetails, setShowDetails] = useState(false);
  const [gridSelect, setGridSelect] = useState([]);
  const [formData, setFormData] = useState({});
  const [activeTab, setActiveTab] = useState('Active');
  const [selectedValues, setSelectedValues] = useState([]);
  const [selected, setSelected] = useState([]);
  const gridRef = useRef(null);
  const StockNotiGridRef = useRef(null);
  const [gridData, setGridData] = useState([]);
  const [maxDeviation, setMaxDeviation] = useState(0);
  const [minDeviation, setMinDeviation] = useState(0);
  const ALL_OPTION = { id: 'all', value: 'All', label: 'Select All' };
  const options = [];

  const fetchStation = async () => {
    try {
      const res = await withRFSToken.post(STATIONS, {})
        .then(function (res) {
          const innerData = res.data.response_data;
          const transformedData = innerData ? innerData.map(item => ({
            id: item.port_Id,
            value: item.code,
            // label: item.code + '-' + item.name
            label: item.code
          })) : [];
          setStationData(transformedData);
        });

    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const fetchTypeCode = async () => {
    try {

      const res = await withRFSToken.post(GETTYPECODE, {})
        .then(function (res) {
          const innerData = res.data.response_data;
          const transformedData = innerData ? innerData.map(item => ({
            value: item.uld_typecode,
            label: item.uld_typecode
          })) : [];
          setGetTypeCodes(transformedData);
        });

    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const getMaxMinDeviation = async () => {
    try {
      const res = await withRFSToken.get('general-setting/get-setting', {})
        .then(function (res) {
          const innerData = res.data.response_data;
          if (innerData && innerData.settings) {
            setMaxDeviation(innerData.settings.maximum_percentage);
            setMinDeviation(innerData.settings.minimum_percentage);
            setNotificationFormData((prev) => ({
              ...prev,
              hours: innerData.settings.frequency || "0", // set default 0 if empty
            }));
          }
        });

    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const handleSelect = (values) => {
    setSelectedValues(values);
  };

  const handleChange = (selected) => {
    setSelected(selected);
  };

  useEffect(() => {
    if (isMounted.current) return;
    fetchStation();
    fetchTypeCode();
    getMaxMinDeviation();
    isMounted.current = true;
  }, []);

  const handleAddButtonClick = () => {
    setModalShow(true);
  };

  const handleAddNotificationButtonClick = () => {
    setNotificationFormData({
      email: '',
      station: [],
      file_type: '',
      id: '',
    });
    setStockAllotmentNotificationModal(true);
  };

  const handleDeviationRangeClick = () => {
    setDeviationRangeModal(true);
  };

  const handleModalClose = () => {
    setModalShow(false);
    setFormData({});
  };

  const closeStockAllotmentNotificationModal = () => {
    setStockAllotmentNotificationModal(false);
    setFormData({});
  };

  const handleAddToGrid = async () => {
    if (
      !formData.station ||
      !formData.type_code ||
      !formData.stock_allotment ||
      !formData.min_stock ||
      !formData.max_stock
    ) {
      toast.error("All fields are mandatory.");
      return;
    }
    const minStock = parseInt(formData.min_stock, 10);
    const maxStock = parseInt(formData.max_stock, 10);
    if (!isNaN(minStock) && !isNaN(maxStock) && maxStock < minStock) {
      toast.error("Maximum Stock cannot be smaller than Minimum Stock.");
      return;
    }
    const payload = { ...formData };
    if (formData.id) {
      payload.id = formData.id;
    }
    try {
      const res = await withRFSToken.post(RULESADDUPDATE, payload)
        .then(function (res) {
          if (res.data.response_code == 200) {
            setModalShow(false);
            toast.success(res.data.response_msg);
            window.$(gridRef.current).jqxGrid('updatebounddata')
            setFormData({});
          } else {
            toast.error(res.data.response_msg);
          }
        });
    } catch (error) {
      console.error('Error sending request:', error);
    }
  };

  useEffect(() => {
    if (gridRef.current) {
      // const token = 'Bearer ' + localStorage.ULD;
      const originalOpen = XMLHttpRequest.prototype.open;
      XMLHttpRequest.prototype.open = function (method, url, ...args) {
        originalOpen.call(this, method, url, ...args);
        // if (url.includes(process.env.REACT_APP_RFS_URL)) {
        this.withCredentials = true;
        // }
      };
      const source = {
        datatype: 'json',
        url: `${process.env.REACT_APP_RFS_URL}rules/list`,
        root: 'Rows',
        id: `${activeTab}-`,
        cache: false,
        datafields: [
          { name: 'id', type: 'string' },
          { name: 'station', type: 'string' },
          { name: 'type_code', type: 'string' },
          { name: 'min_stock', type: 'string' },
          { name: 'max_stock', type: 'string' },
          { name: 'stock_allotment', type: 'string' },
        ],
        // beforeSend: (jqXHR) => {
        //   jqXHR.setRequestHeader('Authorization', token);
        // },
        filter: function (allfilters) {
          window.$(gridRef.current).jqxGrid('clearselection');
          window.$(gridRef.current).jqxGrid("updatebounddata", "filter");
        },
        beforeprocessing: function (data) {
          setGridData(data.Rows);
        }
      };
      const columns = [
        {
          text: 'Action', datafield: '', width: '15%', filtertype: '', filterable: false, sortable: false,
          cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
            return `<div class="grid_actions">
              <img class="door_delete delete-btn" src="${Trash}" data-rowindex="${rowIndex}" style="cursor:pointer;"/>
              <img class="door_delete edit-btn" src="${Edit}" data-rowindex="${rowIndex}" style="cursor:pointer;"/>
            </div>`;
          }
        },
        { text: 'Station', filtertype: 'input', datafield: 'station', width: '15%', cellclassname: '', },
        { text: 'Type Code', filtertype: 'input', datafield: 'type_code', width: '16%', cellclassname: '', },
        { text: 'Minimum Stock', filtertype: 'input', datafield: 'min_stock', width: '16%', cellclassname: '', },
        { text: 'Maximum Stock', filtertype: 'input', datafield: 'max_stock', width: '16%', cellclassname: '', },
        { text: 'Stock Allotment', filtertype: 'input', datafield: 'stock_allotment', width: '16%', cellclassname: '', },
      ];
      const dataAdapter = new window.$.jqx.dataAdapter(source);
      // const gridOptions = {
      //   width: '100%',
      //   source: dataAdapter,
      //   columns: columns,
      //   autoheight: true,
      //   sortable: true,
      //   altrows: false,
      //   enabletooltips: true,
      //   editable: false,
      //   // selectionmode: 'checkbox',
      //   pageable: false,
      //   pageSize: 10,
      //   pagerButtonsCount: 5,
      //   pagerMode: 'advanced',
      //   filterable: true,
      //   filterrowheight: 45,
      //   showfilterrow: true,
      //   rowsheight: 42,
      //   columnsheight: 45,
      // };
      const gridOptions = {
        width: '100%',
        source: dataAdapter,
        columns: columns,
        autoheight: true,
        sortable: true,
        altrows: false,
        columnsresize: false,
        enabletooltips: false,
        editable: false,
        pageable: true,
        pageSize: 50,
        pagerButtonsCount: 5,
        pagerMode: 'advanced',
        filterable: true,
        filterrowheight: 45,
        showfilterrow: true,
        rowsheight: 42,
        columnsheight: 45,
        showstatusbar: true,
        virtualmode: true,
        rendergridrows: function (params) {
          return params.data;
        }
      };
      window.$(gridRef.current).jqxGrid(gridOptions);
      window.$(gridRef.current).find('.jqx-grid-column-header').css('background-color', 'white');

      // window.$(gridRef.current).on('rowclick', (event) => {
      //   const args = event.args.row.bounddata;
      //   const sendRowId = gridData;
      //   setShowDetails(true);
      // });
      window.$(gridRef.current).find('div[role="row"]').each((index, row) => {
        window.$(row).on('mouseover', () => {
          window.$(row).addClass('row-hover');
        });
        window.$(row).on('mouseout', () => {
          window.$(row).removeClass('row-hover');
        });
      });

      window.$(gridRef.current).on('click', '.edit-btn', function () {

        const rowDiv = window.$(this).closest('[role="row"]');
        const rowIndex = window.$(rowDiv).attr('row-id');
        const boundIndex = window.$(gridRef.current).jqxGrid('getrowid', rowIndex);
        if (boundIndex !== undefined) {
          const pagingInfo = window.$(gridRef.current).jqxGrid('getpaginginformation');
          const pageIndex = pagingInfo.pagenum;
          const pageSize = pagingInfo.pagesize;
          const globalIndex = parseInt(rowIndex) + pageIndex * pageSize;
          const rowData = window.$(gridRef.current).jqxGrid('getrowdata', globalIndex);
          console.log('rowData', rowData);

          if (rowData) {
            setFormData({
              id: rowData.id,
              station: rowData.station,
              type_code: rowData.type_code,
              min_stock: rowData.min_stock,
              max_stock: rowData.max_stock,
              stock_allotment: rowData.stock_allotment
            });
            setModalShow(true);
          } else {
            console.error('No data found for the given row index.');
          }
        } else {
          console.error('Bound index could not be retrieved. Check the row index and data binding.');
        }
      });
      window.$(gridRef.current).on('click', '.delete-btn', function () {
        const rowDiv = window.$(this).closest('[role="row"]');
        const rowIndex = window.$(rowDiv).attr('row-id');
        const boundIndex = window.$(gridRef.current).jqxGrid('getrowid', rowIndex);
        if (boundIndex !== undefined) {
          const pagingInfo = window.$(gridRef.current).jqxGrid('getpaginginformation');
          const pageIndex = pagingInfo.pagenum;
          const pageSize = pagingInfo.pagesize;
          const globalIndex = parseInt(rowIndex) + pageIndex * pageSize;
          const rowData = window.$(gridRef.current).jqxGrid('getrowdata', globalIndex);
          if (rowData) {
            // console.log('Row Data:', rowData);
            setFormData({
              id: rowData.id,
              station: rowData.station,
              type_code: rowData.type_code,
              min_stock: rowData.min_stock,
              max_stock: rowData.max_stock
            });
            setConfModal(true);
          } else {
            console.error('No data found for the given row index.');
          }
        } else {
          console.error('Bound index could not be retrieved. Check the row index and data binding.');
        }
      });
      window.$(gridRef.current).on('rowselect', (event) => {
        if (event.args.row) {
          const selectedRow = event.args.row.id;
          if (!gridSelect.includes(selectedRow)) {
            setGridSelect((prevGridSelect) => [...prevGridSelect, selectedRow]);
          }
          setGridSelect((prevGridSelect) => [...prevGridSelect, selectedRow]);
        } else {
          console.log("Select All triggered");
        }
      });
      window.$(gridRef.current).on('rowunselect', (event) => {
        if (event.args.row) {
          const unselectedRowId = event.args.row.id;
          setGridSelect(prevSelection => prevSelection.filter(id => id !== unselectedRowId));
        } else {
          setGridSelect([]);
        }
      });
      window.$(gridRef.current).off('cellclick');
      window.$(gridRef.current).on('cellclick', (event) => {
        const args = event.args.row.bounddata;
        if (event.args.columnindex > 0) {
          if (gridSelect) {
            gridSelect.forEach(item => {
              const selectedRowBoundIndex = item.boundindex;
              window.$(gridRef.current).jqxGrid('unselectrow', selectedRowBoundIndex);
            });
          }
          // loadDetails(args.uld_number);
          // setSelectedRowData(args)
          setTimeout(() => {
            window.$(gridRef.current).jqxGrid('refresh');
          }, 30);
        }
      });
    } else {

    }
  }, []);

  useEffect(() => {
    if (StockNotiGridRef.current) {
      // const token = 'Bearer ' + localStorage.ULD;
      const originalOpen = XMLHttpRequest.prototype.open;
      XMLHttpRequest.prototype.open = function (method, url, ...args) {
        originalOpen.call(this, method, url, ...args);
        // if (url.includes(process.env.REACT_APP_RFS_URL)) {
        this.withCredentials = true;
        // }
      };
      const source = {
        datatype: 'json',
        url: `${process.env.REACT_APP_RFS_URL}org-mail/list`,
        root: 'Rows',
        id: `${activeTab}-`,
        cache: false,
        datafields: [
          { name: 'id', type: 'string' },
          { name: 'file_types', type: 'string' },
          { name: 'email', type: 'string' },
          { name: 'stations', type: 'string' },
          { name: 'status', type: 'string' },
        ],
        // beforeSend: (jqXHR) => {
        //   jqXHR.setRequestHeader('Authorization', token);
        // },
        filter: function (allfilters) {
          window.$(StockNotiGridRef.current).jqxGrid('clearselection');
          window.$(StockNotiGridRef.current).jqxGrid("updatebounddata", "filter");
        },
        beforeprocessing: function (data) {
          setGridData(data.Rows);
        }
      };
      const columns = [
        {
          text: 'Action', datafield: '', width: '15%', filtertype: '', filterable: false, sortable: false,
          cellsrenderer: (rowIndex, dataField, cellValue, defaultHtml, column, data) => {
            return `<div class="grid_actions">
              <img class="door_delete delete-btn" src="${Trash}" data-rowindex="${rowIndex}" style="cursor:pointer;"/>
              <img class="door_delete edit-btn" src="${Edit}" data-rowindex="${rowIndex}" style="cursor:pointer;"/>
            </div>`;
          }
        },
        { text: 'Station', filtertype: 'input', datafield: 'stations', width: '25%', cellclassname: '', },
        { text: 'Email', filtertype: 'input', datafield: 'email', width: '40%', cellclassname: '', },
        { text: 'File Types', filtertype: 'input', datafield: 'file_types', width: '15%', cellclassname: '', },
        // { text: 'Status', filtertype: 'textbox', datafield: 'status', width: '22%', cellclassname: 'frcl', },
      ];
      const dataAdapter = new window.$.jqx.dataAdapter(source);
      // const gridOptions = {
      //   width: '100%',
      //   source: dataAdapter,
      //   columns: columns,
      //   autoheight: true,
      //   sortable: true,
      //   altrows: false,
      //   enabletooltips: true,
      //   editable: false,
      //   // selectionmode: 'checkbox',
      //   pageable: false,
      //   pageSize: 10,
      //   pagerButtonsCount: 5,
      //   pagerMode: 'advanced',
      //   filterable: true,
      //   filterrowheight: 45,
      //   showfilterrow: true,
      //   rowsheight: 42,
      //   columnsheight: 45,
      // };
      const gridOptions = {
        width: '100%',
        source: dataAdapter,
        columns: columns,
        autoheight: true,
        sortable: true,
        altrows: false,
        columnsresize: false,
        enabletooltips: false,
        editable: false,
        pageable: true,
        pageSize: 50,
        pagerButtonsCount: 5,
        pagerMode: 'advanced',
        filterable: true,
        filterrowheight: 45,
        showfilterrow: true,
        rowsheight: 42,
        columnsheight: 45,
        showstatusbar: true,
        virtualmode: true,
        rendergridrows: function (params) {
          return params.data;
        }
      };
      window.$(StockNotiGridRef.current).jqxGrid(gridOptions);
      window.$(StockNotiGridRef.current).find('.jqx-grid-column-header').css('background-color', 'white');

      // window.$(StockNotiGridRef.current).on('rowclick', (event) => {
      //   const args = event.args.row.bounddata;
      //   const sendRowId = gridData;
      //   setShowDetails(true);
      // });
      window.$(StockNotiGridRef.current).find('div[role="row"]').each((index, row) => {
        window.$(row).on('mouseover', () => {
          window.$(row).addClass('row-hover');
        });
        window.$(row).on('mouseout', () => {
          window.$(row).removeClass('row-hover');
        });
      });

      window.$(StockNotiGridRef.current).on('click', '.edit-btn', function () {

        const rowDiv = window.$(this).closest('[role="row"]');
        const rowIndex = window.$(rowDiv).attr('row-id');
        const boundIndex = window.$(StockNotiGridRef.current).jqxGrid('getrowid', rowIndex);
        if (boundIndex !== undefined) {
          const pagingInfo = window.$(StockNotiGridRef.current).jqxGrid('getpaginginformation');
          const pageIndex = pagingInfo.pagenum;
          const pageSize = pagingInfo.pagesize;
          const globalIndex = parseInt(rowIndex) + pageIndex * pageSize;
          const rowData = window.$(StockNotiGridRef.current).jqxGrid('getrowdata', globalIndex);
          console.log('rowData', rowData);

          if (rowData) {
            setNotificationFormData({
              email: rowData.email || '',
              station: rowData.stations
                ? rowData.stations.split(",").map((s, i) => {
                  const trimmed = s.trim();
                  return { id: i + 1, value: trimmed, label: trimmed };
                })
                : [],
              file_types: rowData.file_types
                ? Array.isArray(rowData.file_types)
                  ? rowData.file_types
                  : rowData.file_types.split(',').map(ft => ft.trim())
                : ['Excel'],
              id: rowData.id,
            });
            setStockAllotmentNotificationModal(true);
          } else {
            console.error('No data found for the given row index.');
          }
        } else {
          console.error('Bound index could not be retrieved. Check the row index and data binding.');
        }
      });
      window.$(StockNotiGridRef.current).on('click', '.delete-btn', function () {
        const rowDiv = window.$(this).closest('[role="row"]');
        const rowIndex = window.$(rowDiv).attr('row-id');
        const boundIndex = window.$(StockNotiGridRef.current).jqxGrid('getrowid', rowIndex);
        if (boundIndex !== undefined) {
          const pagingInfo = window.$(StockNotiGridRef.current).jqxGrid('getpaginginformation');
          const pageIndex = pagingInfo.pagenum;
          const pageSize = pagingInfo.pagesize;
          const globalIndex = parseInt(rowIndex) + pageIndex * pageSize;
          const rowData = window.$(StockNotiGridRef.current).jqxGrid('getrowdata', globalIndex);
          if (rowData) {
            setNotificationFormData({
              email: rowData.email || '',
              station: rowData.stations
                ? rowData.stations.split(",").map((s, i) => {
                  const trimmed = s.trim();
                  return { id: i + 1, value: trimmed, label: trimmed };
                })
                : [],
              file_types: rowData.file_types
                ? Array.isArray(rowData.file_types)
                  ? rowData.file_types
                  : rowData.file_types.split(',').map(ft => ft.trim())
                : ['Excel'],
              id: rowData.id,
            });
            setConfNotificationModal(true);
          } else {
            console.error('No data found for the given row index.');
          }
        } else {
          console.error('Bound index could not be retrieved. Check the row index and data binding.');
        }
      });
      window.$(StockNotiGridRef.current).on('rowselect', (event) => {
        if (event.args.row) {
          const selectedRow = event.args.row.id;
          if (!gridSelect.includes(selectedRow)) {
            setGridSelect((prevGridSelect) => [...prevGridSelect, selectedRow]);
          }
          setGridSelect((prevGridSelect) => [...prevGridSelect, selectedRow]);
        } else {
          console.log("Select All triggered");
        }
      });
      window.$(StockNotiGridRef.current).on('rowunselect', (event) => {
        if (event.args.row) {
          const unselectedRowId = event.args.row.id;
          setGridSelect(prevSelection => prevSelection.filter(id => id !== unselectedRowId));
        } else {
          setGridSelect([]);
        }
      });
      window.$(StockNotiGridRef.current).off('cellclick');
      window.$(StockNotiGridRef.current).on('cellclick', (event) => {
        const args = event.args.row.bounddata;
        if (event.args.columnindex > 0) {
          if (gridSelect) {
            gridSelect.forEach(item => {
              const selectedRowBoundIndex = item.boundindex;
              window.$(StockNotiGridRef.current).jqxGrid('unselectrow', selectedRowBoundIndex);
            });
          }
          // loadDetails(args.uld_number);
          // setSelectedRowData(args)
          setTimeout(() => {
            window.$(StockNotiGridRef.current).jqxGrid('refresh');
          }, 30);
        }
      });
    } else {

    }
  }, []);

  // const handleInputChange = (event) => {
  //   const { name, value } = event.target;
  //   if (name === 'stock_allotment') {
  //     formData.min_stock = value - minDeviation;
  //     formData.max_stock = value + maxDeviation;
  //   }
  //   setFormData(prevData => ({
  //     ...prevData,
  //     [name]: value
  //   }));
  // };
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    const numValue = Number(value);
    setFormData((prevData) => {
      let updatedData = { ...prevData, [name]: value };
      if (name === "stock_allotment") {
        const minStock = numValue - (numValue * minDeviation) / 100;
        const maxStock = numValue + (numValue * maxDeviation) / 100;
        updatedData.min_stock = Math.round(minStock);
        updatedData.max_stock = Math.round(maxStock);
      }
      return updatedData;
    });
  };

  const handleConfirmation = (confirm) => {
    if (confirm) {
      handleDoorDelete()
      setConfModal(false);
    } else {
      closeConfirm();
    }
  };

  const handleNotificationConfirmation = (confirm) => {
    if (confirm) {
      handleNotificationDelete()
      setConfNotificationModal(false);
    } else {
      closeNotificationConfirm();
    }
  };

  const closeConfirm = () => {
    setConfModal(false);
  }

  const closeNotificationConfirm = () => {
    setConfNotificationModal(false);
  }

  const closeDeviationRangeModal = () => {
    setDeviationRangeModal(false);
  }

  const handleDoorDelete = async () => {
    const res = await withRFSToken.post(RULESDELETERESTORE, { id: formData.id })
    if (res.data.response_code == 200) {
      if (res.data.response_code == 200) {
        toast.success(res.data.response_msg);
        closeConfirm();
        window.$(gridRef.current).jqxGrid('updatebounddata')
      } else {
        toast.error(res.data.response_msg);
      }
    } else {
      toast.error(res.data.response_msg);
    }
  };

  const handleNotificationDelete = async () => {
    const res = await withRFSToken.post('org-mail/delete-restore', { id: notificationFormData.id })
    if (res.data.response_code == 200) {
      if (res.data.response_code == 200) {
        toast.success(res.data.response_msg);
        closeNotificationConfirm();
        window.$(StockNotiGridRef.current).jqxGrid('updatebounddata')
      } else {
        toast.error(res.data.response_msg);
      }
    } else {
      toast.error(res.data.response_msg);
    }
  };

  const deviationRangeSave = async () => {
    if (!minDeviation || !maxDeviation) {
      toast.error("Please enter both minimum and maximum deviation values.");
      return;
    }
    const res = await withRFSToken.post('general-setting/save-setting', { settings: { minimum_percentage: minDeviation, maximum_percentage: maxDeviation } });
    if (res.data.response_code === 200) {
      toast.success(res.data.response_msg);
      closeDeviationRangeModal();
      window.$(gridRef.current).jqxGrid('updatebounddata');
    } else {
      toast.error(res.data.response_msg);
    }
  };

  const [notificationFormData, setNotificationFormData] = useState({
    hours: '',
    email: '',
    station: [],
    file_types: ['Excel'], // default to Excel
  });

  const handleNotificationChange = (e) => {
    const { name, value } = e.target;
    setNotificationFormData((prev) => ({
      ...prev,
      [name]: value
    }));
  };

  const handleStationChange = (selectedOptions) => {
    setNotificationFormData((prev) => ({
      ...prev,
      station: selectedOptions
    }));
  };

  const handleNotificationSave = async () => {
    if (!notificationFormData.email || !notificationFormData.station || notificationFormData.station.length === 0 || !notificationFormData.file_types || notificationFormData.file_types.length === 0) {
      toast.error("All fields are mandatory.");
      return;
    }
    let stations;
    if (notificationFormData.station.some(opt => opt.value === 'All')) {
      stations = ['All'];
    } else {
      stations = notificationFormData.station.map(s => s.value);
    }
    const payload = {
      stations: stations,
      email: notificationFormData.email,
      id: notificationFormData.id,
      file_types: notificationFormData.file_types // now an array
    };
    const res = await withRFSToken.post('org-mail/add-update', payload);
    if (res.data.response_code === 200) {
      toast.success('Notification settings saved successfully');
      window.$(StockNotiGridRef.current).jqxGrid('updatebounddata')
      closeStockAllotmentNotificationModal();
    } else {
      toast.error(res.data.response_msg);
    }

  };

  const handleFrequencySave = async () => {
    const res = await withRFSToken.post('general-setting/save-setting', { settings: { frequency: notificationFormData.hours } });
    if (res.data.response_code === 200) {
      toast.success(res.data.response_msg);
      closeDeviationRangeModal();
      window.$(gridRef.current).jqxGrid('updatebounddata');
    } else {
      toast.error(res.data.response_msg);
    }
  };

  const SBack = localStorage.getItem('SettingsBack');

  return (
    <>
      {/* <div className="">
        <Header logo_url={SBack ? SBack : '/ULDControl'} sBackUrl={SBack ? SBack : '/ULDControl'}  />
        <div className="page-body-wrapper schedule">
          <LeftMenu />
          <div className="main-panel">
            <div className="row">
              <LeftSettings /> */}
              <div className='col-9 col-xxl-9'>
                <div className='row'>
                  <div className='col-6 col-xxl-6'>
                    <div className='settingbg_right'>
                      <h4>Stock Allotment Settings</h4>
                      <p>Set your Stock Allotment Settings by adding the rule.</p>
                      <div className='row'>
                        <div className='col-12'>
                          <div className='d-flex justify-content-between mb-3'>
                            <Button variant="primary createplan mb-0" onClick={handleAddButtonClick}>
                              <FontAwesomeIcon icon={faPlus} /> Add Rule
                            </Button>
                            <Button variant="primary extra_button mb-0" onClick={handleDeviationRangeClick}>
                              {/* <FontAwesomeIcon icon={faPlus} />  */}Deviation Range
                            </Button>
                          </div>
                          <div ref={gridRef} className='staion_grid' ></div>
                        </div>
                      </div>

                    </div>
                  </div>
                  <div className='col-6 col-xxl-6'>
                    <div className='settingbg_right'>
                      <h4>Automatic Stock Allotment Notification</h4>
                      <p>Send stock allotment reports by email automatically.</p>
                      <div className='d-flex justify-content-between mb-3 align-items-center'>
                        <Row>
                          <Col md="8">
                            <Form.Group className=''>
                              {/* <Form.Label>Frequency</Form.Label> */}
                              <InputGroup>
                                <Form.Control
                                  type="number"
                                  value={notificationFormData.hours}
                                  name='hours'
                                  onInput={(e) => { e.target.value = e.target.value.replace(/\D/g, '').slice(0, 3); }}
                                  onChange={handleNotificationChange}
                                />
                                <InputGroup.Text>Hour</InputGroup.Text>
                                <Button variant="primary extra_button" onClick={handleFrequencySave}>
                                  Save
                                </Button>
                              </InputGroup>
                            </Form.Group>
                          </Col>
                        </Row>
                        <Button variant="primary createplan mb-0" onClick={handleAddNotificationButtonClick}>
                          <FontAwesomeIcon icon={faPlus} /> Add Rule
                        </Button>
                      </div>
                      <div ref={StockNotiGridRef} className='staion_grid' ></div>
                    </div>
                  </div>
                </div>
              </div>
            {/* </div>
          </div>
        </div>
      </div> */}
      <Modal show={confModal} onHide={closeConfirm} className="addfrom change_type" centered>
        <Modal.Header closeButton onClick={closeConfirm}></Modal.Header>
        <Modal.Body>
          <h3>The Rule will be deleted. </h3>
          <p>Are you sure you want to continue?</p>
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex w-50 mx-auto are_bottom">
            <Button variant="secondary" onClick={() => handleConfirmation(false)}> No</Button>
            <Button variant="primary" onClick={() => handleConfirmation(true)}> Yes </Button>
          </div>
        </Modal.Footer>
      </Modal>

      <Modal show={confNotificationModal} onHide={closeNotificationConfirm} className="addfrom change_type" centered>
        <Modal.Header closeButton onClick={closeNotificationConfirm}></Modal.Header>
        <Modal.Body>
          <h3>The Notification Rule will be deleted. </h3>
          <p>Are you sure you want to continue?</p>
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex w-50 mx-auto are_bottom">
            <Button variant="secondary" onClick={() => handleNotificationConfirmation(false)}> No</Button>
            <Button variant="primary" onClick={() => handleNotificationConfirmation(true)}> Yes </Button>
          </div>
        </Modal.Footer>
      </Modal>

      <Modal show={deviationRangeModal} onHide={closeDeviationRangeModal} className="addfrom change_type" centered>
        <Modal.Header closeButton onClick={closeDeviationRangeModal}></Modal.Header>
        <Modal.Body>
          <h3>Deviation Settings</h3>
          <p>Define the allowed percentage deviation from stock allotment (Min - Max)</p>
          <Form.Group>
            <Form.Label>Minimum Deviation %</Form.Label>
            <Form.Control
              type="number"
              placeholder="Minimum Deviation %"
              value={minDeviation}
              name="min_deviation"
              onChange={(e) => setMinDeviation(e.target.value)}
            />
          </Form.Group>
          <Form.Group className='mt-3'>
            <Form.Label>Maximum Deviation %</Form.Label>
            <Form.Control
              type="number"
              placeholder="Maximum Deviation %"
              value={maxDeviation}
              name="max_deviation"
              onChange={(e) => setMaxDeviation(e.target.value)}
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex w-50 mx-auto are_bottom">
            <Button variant="secondary" onClick={closeDeviationRangeModal}> Cancel</Button>
            <Button variant="primary" onClick={() => deviationRangeSave()}> Save </Button>
          </div>
        </Modal.Footer>
      </Modal>

      <Modal show={modalShow} centered onHide={handleModalClose} className='addfrom' >
        <Modal.Header closeButton>
          <Modal.Title>Add Stock Allotment Rule</Modal.Title>
          <p>Define ULD Stock limits for a station below</p>
        </Modal.Header>
        <Modal.Body>
          <Form.Group controlId="dropdown">
            <Form.Label>Station Name <span style={{ color: 'red' }}>*</span></Form.Label>
            <Select
              options={stationData}
              placeholder="Station Name"
              className='down_selct'
              onChange={(selected) => {
                setFormData({ ...formData, station: selected.value });
              }}
              name="station"
              value={stationData.find(opt => opt.value === formData.station) || null}
            />
          </Form.Group>
          <Form.Group controlId="dropdown" className='mt-3'>
            <Form.Label>Type Code <span style={{ color: 'red' }}>*</span></Form.Label>
            <Select
              options={getTypeCodes}
              placeholder="Type Code"
              className='down_selct'
              onChange={(selected) => {
                setFormData({ ...formData, type_code: selected.value });
              }}
              name="type_code"
              value={getTypeCodes.find(opt => opt.value === formData.type_code) || null}
            />
          </Form.Group>
          <Form.Group controlId="dropdown" className='mt-3'>
            <Form.Label>Stock Allotment <span style={{ color: 'red' }}>*</span></Form.Label>
            <Form.Control
              type="number"
              onInput={(e) => { e.target.value = e.target.value.replace(/\D/g, '').slice(0, 50); }}
              value={formData.stock_allotment}
              name='stock_allotment'
              onChange={handleInputChange}
              placeholder="Stock Allotment"
            />
          </Form.Group>
          <Form.Group controlId="dropdown" className='mt-3'>
            <Form.Label>Minimum Stock <span style={{ color: 'red' }}>*</span></Form.Label>
            <Form.Control
              type="number"
              onInput={(e) => { e.target.value = e.target.value.replace(/\D/g, '').slice(0, 50); }}
              value={formData.min_stock || ''}
              name='min_stock'
              onChange={handleInputChange}
              placeholder="Minimum Stock"
            />
          </Form.Group>
          <Form.Group controlId="dropdown" className='mt-3'>
            <Form.Label>Maximum Stock <span style={{ color: 'red' }}>*</span></Form.Label>
            <Form.Control
              type="number"
              onInput={(e) => { e.target.value = e.target.value.replace(/\D/g, '').slice(0, 50); }}
              value={formData.max_stock || ''}
              name='max_stock'
              onChange={handleInputChange}
              placeholder="Maximum Stock"
            />
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="primary" onClick={handleAddToGrid}>
            Add Rule
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal show={stockAllotmentNotificationModal} onHide={closeStockAllotmentNotificationModal} className="addfrom change_type" centered>
        <Modal.Header closeButton onClick={closeStockAllotmentNotificationModal}></Modal.Header>
        <Modal.Body>
          <h3>Deviation Settings</h3>
          <p>Define the allowed percentage deviation from stock allotment (Min - Max)</p>
          <Form.Group className='mb-2'>
            <Form.Label>Email Address <span style={{ color: 'red' }}>*</span></Form.Label>
            <Form.Control
              type="email"
              value={notificationFormData.email}
              name='email'
              onChange={handleNotificationChange}
            />
          </Form.Group>
          <Form.Group className='mb-2'>
            <Form.Label>Station <span style={{ color: 'red' }}>*</span></Form.Label>
            <Select
              options={[ALL_OPTION, ...stationData]}
              placeholder="Station Name"
              className='down_selct'
              name="station"
              isMulti
              value={notificationFormData.station}
              onChange={handleStationChange}
            />
          </Form.Group>
          <Form.Group className='mb-2'>
            <Form.Label>File Type <span style={{ color: 'red' }}>*</span></Form.Label>
            <div className='d-flex align-items-center'>
              <Form.Check
                type="checkbox"
                id="checkbox_excel"
                name='file_type_excel'
                label="Excel"
                value="Excel"
                checked={notificationFormData.file_types?.includes("Excel")}
                onChange={e => {
                  setNotificationFormData(prev => {
                    let file_types = prev.file_types || [];
                    if (e.target.checked) {
                      file_types = [...file_types, "Excel"];
                    } else {
                      file_types = file_types.filter(ft => ft !== "Excel");
                    }
                    return { ...prev, file_types };
                  });
                }}
              />
              <Form.Check
                type="checkbox"
                id="checkbox_pdf"
                name='file_type_pdf'
                label="PDF"
                value="PDF"
                checked={notificationFormData.file_types?.includes("PDF")}
                onChange={e => {
                  setNotificationFormData(prev => {
                    let file_types = prev.file_types || [];
                    if (e.target.checked) {
                      file_types = [...file_types, "PDF"];
                    } else {
                      file_types = file_types.filter(ft => ft !== "PDF");
                    }
                    return { ...prev, file_types };
                  });
                }}
              />
            </div>
          </Form.Group>
        </Modal.Body>
        <Modal.Footer>
          <div className="d-flex w-50 mx-auto are_bottom">
            <Button variant="secondary" onClick={closeStockAllotmentNotificationModal}> Cancel</Button>
            <Button variant="primary" onClick={handleNotificationSave}> Save </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  )
}

export default StockAllotmentSettings;